import {FC} from "react"

import {useBooleanState} from "@frontend/utils/useBooleanState"
import {css} from "@styled-system/css"

import {ConsentModal} from "./consent-modal"

export const AIDisclaimer: FC = () => {
  const {
    state: showModal,
    setTrue: openModal,
    setFalse: closeModal,
  } = useBooleanState(false)

  return (
    <>
      <p
        className={css({
          textStyle: "caption",
          color: "text.tertiary",
          margin: 0,
          textAlign: "center",
          paddingX: 12,
          paddingY: 6,
        })}
      >
        {"AI-generated suggestions. "}
        <button
          onClick={openModal}
          className={css({
            textStyle: "caption",
            color: "text.tertiary",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            textDecoration: "underline",
            _hover: {
              opacity: 0.7,
            },
          })}
        >
          {"Learn more"}
        </button>
      </p>

      <ConsentModal show={showModal} onClose={closeModal} />
    </>
  )
}
